import React from 'react';
import { NavLink } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { COMPANY_INFO } from '../data/content';

export function Forbidden() {
  return (
    <>
      <SEO
        title="403 – Adgang Nægtet"
        description="Du har ikke tilladelse til at tilgå denne side på Vægsystem3e.dk."
      />

      <section className="min-h-[70vh] bg-slate-950 text-white flex items-center justify-center py-20 px-4">
        <div className="max-w-xl mx-auto text-center">
          <div className="w-20 h-20 bg-red-600/20 text-red-500 rounded-3xl border border-red-500/30 flex items-center justify-center text-3xl mx-auto mb-6 shadow-2xl">
            <i className="fa-solid fa-lock" aria-hidden="true" />
          </div>

          <span className="text-[#819FA8] font-extrabold text-xs uppercase tracking-widest block mb-2">
            Fejl 403 – Begrænset Adgang
          </span>

          <h1 className="text-3xl sm:text-5xl font-black text-white tracking-tight mb-4">
            Adgang Nægtet
          </h1>

          <p className="text-slate-300 text-sm sm:text-base leading-relaxed mb-8">
            Du har desværre ikke den nødvendige tilladelse til at tilgå denne område. Vende venligst tilbage til forsiden.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <NavLink
              to="/"
              className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-3.5 rounded-xl text-sm transition-all shadow-lg flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true" />
              <span>Tilbage til forsiden</span>
            </NavLink>

            <NavLink
              to="/kontakt"
              className="w-full sm:w-auto bg-slate-800 hover:bg-slate-700 text-slate-200 font-bold px-8 py-3.5 rounded-xl text-sm transition-all border border-slate-700 flex items-center justify-center gap-2"
            >
              <span>Kontakt os</span>
            </NavLink>
          </div>
        </div>
      </section>
    </>
  );
}
